import { render, staticRenderFns } from "./ForestOpportunity.vue?vue&type=template&id=2bf25ba0&scoped=true"
import script from "./ForestOpportunity.vue?vue&type=script&lang=js"
export * from "./ForestOpportunity.vue?vue&type=script&lang=js"
import style0 from "./ForestOpportunity.vue?vue&type=style&index=0&id=2bf25ba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf25ba0",
  null
  
)

export default component.exports